import React, { useState } from "react";

const Projects = () => {
  const [filter, setFilter] = useState("all");

  const projects = [
    { id: 1, img: "/img/portfolio-1.jpg", name: "Project 1", type: "complete" },
    { id: 2, img: "/img/portfolio-2.jpg", name: "Project 2", type: "running" },
    { id: 3, img: "/img/portfolio-3.jpg", name: "Project 3", type: "upcoming" },
    { id: 4, img: "/img/portfolio-4.jpg", name: "Project 4", type: "complete" },
    { id: 5, img: "/img/portfolio-5.jpg", name: "Project 5", type: "running" },
    { id: 6, img: "/img/portfolio-6.jpg", name: "Project 6", type: "upcoming" },
  ];

  // Filter logic
  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((p) => p.type === filter);

  return (
    <div className="container-fluid py-5">
      <div className="container py-5">

        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center mb-4">
            <h6 className="text-primary text-uppercase mb-3">
              Our Projects
            </h6>
            <h1>Some Of Our Awesome Interior Designing Projects</h1>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="text-center mb-4">
          <button
            className={`btn m-1 ${filter === "all" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setFilter("all")}
          >
            All
          </button>

          <button
            className={`btn m-1 ${filter === "complete" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setFilter("complete")}
          >
            Completed
          </button>

          <button
            className={`btn m-1 ${filter === "running" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setFilter("running")}
          >
            Running
          </button>

          <button
            className={`btn m-1 ${filter === "upcoming" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setFilter("upcoming")}
          >
            Upcoming
          </button>
        </div>

        {/* Projects Grid */}
        <div className="row">
          {filteredProjects.map((p) => (
            <div key={p.id} className="col-lg-4 col-md-6 mb-4">
              <div className="position-relative overflow-hidden">

                <img
                  src={p.img}
                  alt={p.name}
                  className="img-fluid w-100"
                />

                {/* Overlay */}
                <div
                  className="d-flex flex-column align-items-center justify-content-center position-absolute w-100 h-100"
                  style={{
                    top: 0,
                    left: 0,
                    background: "rgba(0,0,0,0.6)",
                    opacity: 0,
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
                >
                  <h4 className="text-white mb-3">{p.name}</h4>

                  <div>
                    <button className="btn btn-outline-light m-1">
                      <i className="fa fa-link"></i>
                    </button>
                    <button className="btn btn-outline-light m-1">
                      <i className="fa fa-eye"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Projects;